import { useEffect, useRef } from "react";

const useOutsideClick = (ref: any, callback: () => void) => {
  // Kept in a ref so the listener is attached once but never calls a stale
  // closure.
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const path = event.composedPath?.() ?? [];
      if (!ref.current || !path.includes(ref.current)) {
        callbackRef.current();
      }
    };
    // Capture phase on `document`: side panels/modals call stopPropagation on
    // their own clicks, so a bubbling listener on document.body never sees
    // clicks made inside them and the popup could never be closed.
    document.addEventListener("click", handleOutsideClick, true);
    return () =>
      document.removeEventListener("click", handleOutsideClick, true);
  }, [ref]);
};

export default useOutsideClick;
